export default {"src":"/_next/static/media/Alejandro-Cartagena2.3387d811.JPG","height":544,"width":366};